export enum LANGUAGE {
    GERMAN = 'de',
    ENGLISH = 'en'
}

export class Settings {
    public language: LANGUAGE = LANGUAGE.GERMAN;
    public highAccuracyLocation: boolean = false;
}
